import React from 'react'
import {prodConfig} from "../config";

class NewIndexPage extends React.Component {
    constructor() {
        window.location.replace(`${prodConfig.MAIN_URL}/homepage?from=outside_site`)
        super()
    }
    render() {
        return (
            <div style={{display: 'none'}}>loading</div>
        )
    }
}

export default NewIndexPage


// WEBPACK FOOTER //
// ./src/pages/NewIndexPage.js